import { createSelector } from 'reselect';

const sectionNameSelector = (state, props) => props.section;
const formNameSelector = (state, props) => props.stage;
const formSelector = (state, props) =>
	state.forms[props.section] && state.forms[props.section][props.stage];
const valuesSelector = (state) => state.values;
const uploadsSelector = (state, props) => state.uploads.files[props.name];

/**
 * Form fields selector
 * @param  {Function} formSelector Function that returns the form by name
 * @return {String}                The form fields
 */
export const formFieldsSelector = createSelector(
	formSelector,
	valuesSelector,
	sectionNameSelector,
	formNameSelector,
	(form, values, section, formName) => {
		let formFields = [];

		// Filter fields to not include fields that
		// have a 'showWhen' property. These fields
		// should only be appended to the fields array
		// when their showWhen field's value matches.
		if (form && form.fields) {
			formFields = form.fields.filter((field) => {
				if (!('showWhen' in field)) {
					return true;
				}

				const name = Object.keys(field.showWhen)[0];
				const value = field.showWhen[name];
				const fieldName = `${section}_${formName}_${name}`;

				if (
					values[fieldName] &&
					typeof values[fieldName] !== 'string' &&
					values[fieldName].length
				) {
					return values[fieldName].indexOf(value) !== -1;
				} else {
					return values[fieldName] === value;
				}
			});
		}

		return formFields;
	},
);

/**
 * Form values selector
 * @param  {Function} formSelector Function that returns the form by name
 * @return {Object}                The form values
 */
export const formValuesSelector = createSelector(
	sectionNameSelector,
	formNameSelector,
	valuesSelector,
	(sectionName, formName, values) => {
		const formValues = {};
		const keyPrefix = `${sectionName}_${formName}_`;

		Object.keys(values).forEach((fieldName) => {
			const regex = new RegExp(`^(${keyPrefix})`, 'g');

			if (regex.test(fieldName)) {
				formValues[fieldName] = values[fieldName];
			}
		});

		return formValues;
	},
);

export const uploadedFilesSelector = createSelector(
	uploadsSelector,
	(files) => files || [],
);
